import { RelatedObjects } from '@sweep-io/sweep-design/dist/icons';
import { CanvasToolbarButton } from './CanvasToolbarButton';
import { usePanels } from '../../../../panels/usePanels';
import { useHandleCommentsAndAiFirst } from '../left-menu/useHandleCommentsAndAiFirst';
import { metadataElementsPanelType } from '../../../funnel-map-flow/dialogs/metadata-elements/metadataElementsPanelType';
import { useAreAllPermissionsAllowed } from '../../../../common/permissions/usePermission';
import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useEffect } from 'react';

export const MetadataElementsToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { maybeOpenPanel } = usePanels();
  const handleCommentsAndAiFirst = useHandleCommentsAndAiFirst();
  const { isPanelOpen, maybeCloseSpecificPanel } = usePanels();
  const isMetadataElementsPanelOpen = isPanelOpen(metadataElementsPanelType);

  const createFunnelsPermissions = useAreAllPermissionsAllowed(['create:funnels', 'edit:funnels']);
  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();

  useEffect(() => {
    if (activeExclusiveButton !== 'metadataElements' && isMetadataElementsPanelOpen) {
      maybeCloseSpecificPanel(metadataElementsPanelType);
    }
  }, [
    activeExclusiveButton,
    isMetadataElementsPanelOpen,
    maybeCloseSpecificPanel,
    setActiveExclusiveButton,
  ]);

  return (
    <CanvasToolbarButton
      tooltip="Add Metadata Elements"
      disabledTooltip={
        createFunnelsPermissions ? '' : 'To add Metadata Elements, please contact your admin.'
      }
      onToggle={(pressed: boolean) => {
        if (pressed) {
          handleCommentsAndAiFirst(() => {
            maybeOpenPanel({
              panelType: metadataElementsPanelType,
              onOpen: () => setActiveExclusiveButton('metadataElements'),
              onClose: () => setActiveExclusiveButton(null),
            });
          });
        } else {
          maybeCloseSpecificPanel(metadataElementsPanelType, undefined, { forceClose: true });
        }
      }}
      pressed={isMetadataElementsPanelOpen}
      disabled={!createFunnelsPermissions || isDisabled}
      testId="add-metadata-elements-button"
    >
      <RelatedObjects />
    </CanvasToolbarButton>
  );
};
